import { MutableRefObject, createContext } from "react";

const SnackbarContext = createContext<MutableRefObject<any> | undefined>(
  undefined
);

export default SnackbarContext;
